import "../../../common/js/3rdparty/date.js";
import "../../../common/js/3rdparty/prism.js";

import $ from "webpack-zepto";
window.$ = $;

import Accordion from "../../../common/js/Accordion.js";
import Ajax from "../../../common/js/Ajax.js";
import Navigation from "../../../common/js/Navigation.js";
import WidgetLoader from "../../../common/js/WidgetLoader.js";
import ZoomImage from "../../../common/js/image/ZoomImage.js";

import ContactFormWidget from "./contact/ContactFormWidget.js";
import DatePickerWidget from "../../../common/js/datepicker/DatePickerWidget.js";
import DropDownWidget from "../../../common/js/dropdown/DropDownWidget.js";

$(() => {
	Ajax.initialize();

	Accordion.initialize();
	Navigation.initialize();
	ZoomImage.initialize();

	WidgetLoader.add("ContactFormWidget", ContactFormWidget);
	WidgetLoader.add("DatePickerWidget", DatePickerWidget);
	WidgetLoader.add("DropDownWidget", DropDownWidget);

	WidgetLoader.initialize();
});
